type PlaybackRateTarget = Pick<HTMLMediaElement, "playbackRate">;

export function normalizeWebPlaybackRate(rate: number): number {
  return Number.isFinite(rate) && rate > 0 ? Math.min(rate, 16) : 1;
}

/**
 * Playback speed is continuous queue intent. Mirror it into both the active
 * and prewarmed media elements so promotion cannot expose a one-speed frame.
 */
export function mirrorWebQueuePlaybackRate(
  rate: number,
  elements: Array<PlaybackRateTarget | null | undefined>
): number {
  const normalized = normalizeWebPlaybackRate(rate);
  for (const element of elements) {
    if (element) element.playbackRate = normalized;
  }
  return normalized;
}
